// Helpers shared by the simple and language playbook builders.

// An event date from the API ("YYYY-MM-DD") shown as that calendar day. new Date("2026-11-08")
// is midnight UTC, which is the day before anywhere west of Greenwich.
export function formatEventDate(date) {
  if (!date) return 'N/A';
  const text = String(date);
  const parsed = /^\d{4}-\d{2}-\d{2}/.test(text)
    ? new Date(Number(text.slice(0, 4)), Number(text.slice(5, 7)) - 1, Number(text.slice(8, 10)))
    : new Date(text);
  return parsed.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' });
}

// The reason an API call failed, for showing to the user: the backend's { error, detail } or the
// API's { detail }, else the plain text, else `fallback`.
export async function readApiError(response, fallback) {
  const text = await response.text().catch(() => '');
  try {
    const body = JSON.parse(text);
    const reason = body.detail || body.error;
    if (reason) return `${fallback}: ${typeof reason === 'string' ? reason : JSON.stringify(reason)}`;
  } catch (e) {
    // not JSON
  }
  return text ? `${fallback}: ${text.slice(0, 300)}` : fallback;
}

// The id the data job stores an event under (publish.event_id_for): lower case, spaces to
// underscores, no colons or full stops. Picks carry it so the job can score them after the event.
export function eventIdFor(eventName) {
  return String(eventName || '').toLowerCase().replace(/ /g, '_').replace(/:/g, '').replace(/\./g, '');
}

// A pick from the API's /picks as it is saved on a playbook, tagged with its event
export function savedPick(pick, eventName, eventDate) {
  return {
    pick_name: pick.pick,
    opponent_name: pick.opponent,
    budget_amount: pick.augmented_weight,
    american_odds: pick.odds_us,
    decimal_odds: parseFloat(pick.odds),
    supporting_strategies: pick.strategy?.length || 0,
    type: pick.pick_type.toLowerCase(),
    event: { name: eventName, date: eventDate, id: eventIdFor(eventName) },
  };
}
